<template>
  <div>
    <invoice-item-skeleton v-for="n in 7" :key="n" />
  </div>
</template>
<script>
import InvoiceItemSkeleton from '@/portal-components/invoice/invoice-item-skeleton';

export default {
  name: 'InvoiceListSkeleton',
  components: { InvoiceItemSkeleton },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-list-skeleton.vue